import * as actionTypes from '../actions/ActionTypes'

export default function(state = [], action) {
  switch (action.type) {
    case actionTypes.LISTS_CUSTOMER_SURVEY_UPDATE:
      return action.listsCustomerSurvey
    default:
      return state
  }
}